import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class SoilUnitWeightGamaCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (SoilUnitWeightGamaCalculationMethodModel._instance == null) SoilUnitWeightGamaCalculationMethodModel._instance = new SoilUnitWeightGamaCalculationMethodModel(authManager);
        return SoilUnitWeightGamaCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/soil-unit-weight-gama-calculation-methods', 'geo-sections/soil-unit-weight-gama-calculation-methods/codelist');

        this.entityName = 'geo-sections.SoilUnitWeightGamaCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Soil Unit Weight Gama Calc Method';
        this.setLabel = 'Soil Unit Weight Gama Calc Methods';

        this.browser = {
            name: 'default-geo-sections-soilunitweightgamacalculationmethod-browser',
            moduleName: 'default-geo-sections-soilunitweightgamacalculationmethod-browser',
            moduleTitle: 'Soil Unit Weight Gama Calc Methods',
            moduleStateSlotName: 'default-geo-sections-soilunitweightgamacalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-soilunitweightgamacalculationmethod-editor',
            moduleName: 'default-geo-sections-soilunitweightgamacalculationmethod-editor',
            moduleTitle: 'Soil Unit Weight Gama Calc Method',
            moduleStateSlotName: 'default-geo-sections-soilunitweightgamacalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
